  <style>
    td,
    th {
        border: 1px solid #dddddd;
        margin-left: 5.4pt;
        padding: 0in 5.4pt 0in 5.4pt
    }


</style>

<body style="font-family: 'Arial'; font-size: 18pt;">
    

    <p >OHA Voucher #&nbsp;&nbsp;<span><u>{{voucherId}}</u></span></p>

    <p style='text-align:center'>
        <b>
            <span >
                Oregon Health Authority<br />
            </span>
        </b>
        
        <span >
            Environmental<br />
            Public Health – Domestic Well Program <br />
            Chain of Custody Form<br />
        </span>
    </p>

    <!--Sample info-->
    <span>
        <span>
            SAMPLE INFORMATION:
            <span> &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp; &nbsp;&nbsp;&nbsp;
            &nbsp; &nbsp;&nbsp;&nbsp;</span>
           
            URC Courier Fee:
        </span><br />
    </span>
    <table border=1 cellspacing=0 cellpadding=0 width=1200px style='padding:0in 5.4pt 0in 5.4pt;margin-left:5.4pt;border-collapse:collapse;border:none;'>

        <tr>
            <td style='padding:0in 5.4pt 0in 5.4pt' colspan="2">
                <br />
                <b>
                    <span>
                        Sample Collection Date/Time:
                        <u>
                            &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </u>
                        &nbsp;AM / PM
                    </span>
                    &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>
                        Collected By:
                        <u>
                            &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </u>
                    </span>
                </b>
                <br />
                <br />
                <span>
                    <strong>Sample Address:</strong>
                    <u>
                        {{wellAddress}}
                    </u>
                    &nbsp;
                </span>
                <br />
                <br />
                <span>
                    <strong>Sample Source:</strong>
                    <input type="checkbox" name="Well" value="Well"> Well &nbsp;
                    <input type="checkbox" name="Other" value="Other"> Other ____________________________________&nbsp;
                    <br /><br />
                    <strong>Sample Point:</strong>
                    <input type="checkbox" name="Well" value="Well"> Well &nbsp;
                    <input type="checkbox" name="Well" value="Well"> Kitchen Sink &nbsp;
                    <input type="checkbox" name="Well" value="Well"> Outside Faucet &nbsp;
                </span>

                <br />
                <br />

                <table style="width: 100%; border: none;" border=0>
                    <tr style="border: none;" >
                        <td style="border: none;">
                            <u><span>Tests Required &nbsp;</span></u>
                        </td>

                        <td style="border: none;">
                            <u><span>Test Type&nbsp;</span></u>
                        </td>
                    </tr>
                    <tr style="border: none;">
                        <td style="border: none;">
                            <span *ngIf="testsRequired == 'FullPanel'"><input type="checkbox" name="FullPanel" value="FullPanel" checked > OHA Full Panel &nbsp;</span>
                            <span *ngIf="testsRequired == 'NitrateOnly'"><input type="checkbox" name="NitrateOnly" value="NitrateOnly" checked> Nitrate Only &nbsp;</span>
                        </td>

                        <td style="border: none;">
                            <span *ngIf="testType == 'Initial'"><input type="checkbox" name="Initial" value="Initial" checked> Initial &nbsp;</span>
                            <span *ngIf="testType == 'Annual'"><input type="checkbox" name="Annual" value="Annual" checked> Annual Re-test &nbsp;</span>
                            <span *ngIf="testType == 'Quarterly'"><input type="checkbox" name="Quarterly" value="Quarterly" checked> Quarterly &nbsp;</span>
                            <br />
                            <span *ngIf="testType == 'Quarterly' && quarter != 0">
                                <span *ngIf="quarter == 1"><input type="radio" id="Quarter" name="Quarter" value="Q1" checked> Q1 &nbsp;</span>
                                <span *ngIf="quarter == 2"><input type="radio" id="Quarter" name="Quarter" value="Q2" checked> Q2 &nbsp;</span>
                                <span *ngIf="quarter == 3"><input type="radio" id="Quarter" name="Quarter" value="Q3" checked> Q3 &nbsp;</span>
                                <span *ngIf="quarter == 4"><input type="radio" id="Quarter" name="Quarter" value="Q4" checked> Q4 &nbsp;</span>
                            </span>
                        </td>
                    </tr>
                    <tr style="border: none;"><td  style="border: none;" colspan="2">&nbsp;</td></tr>
                </table>

            </td>
        </tr>
    </table>

    <br />

    <!--Cutomer info-->
    <span>
        CLIENT/ BILLING INFORMATION:<br />
    </span>
    <table border=1 cellspacing=0 cellpadding=0 width=1200px
    style='padding:0in 5.4pt 0in 5.4pt;margin-left:5.4pt;border-collapse:collapse;border:none'>


        <tr>
            <td style='padding:0in 5.4pt 0in 5.4pt;' colspan="2">
                <br />
                <span>
                    Customer Name:
                    <u>
                        {{customerName}}
                    </u>
                </span>
                <br />
                <br />
                <span>
                    Mailing Address:
                    <u>
                        {{mailingAddress}}
                    </u>
                    &nbsp;&nbsp;
                </span>
                <span>
                    <span>
                        City:
                        <u>
                            {{mailingCity}}
                        </u>
                        &nbsp;&nbsp;
                        State:
                        <u>
                            {{mailingState}}
                        </u>
                        &nbsp;&nbsp;
                        Zip:
                        <u>
                            {{mailingZip}}
                        </u>

                    </span>
                </span>
                <br />
                <br />
                <span>
                    Phone:
                    <u>
                        {{phone}}
                    </u>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    E-Mail:
                    <u>
                        {{email}}
                    </u>
                </span>
                <br />
                <br />
                <span>
                    <b>Report Delivery: </b>
                    <span>
                        <input type="radio" id="delivery" name="delivery" value="email"> E-Mail &nbsp;
                        <input type="radio" id="delivery" name="delivery" value="mail"> Hard Copy by Mail &nbsp;
                    </span>
                </span>
                <br />
                <br />
            </td>
        </tr>
    </table>
    <br />

    <span>
        RESIDENTIAL/REAL ESTATE TRANSACTIONS - STOP HERE <br />                
        PUBLIC WATER SYSTEM OPERATORS ONLY: PWS# 41- 
    </span>
    <br />
    <!--water system only info-->  
    <table border=1 cellspacing=0 cellpadding=0 width=1200px style='padding:0in 5.4pt 0in 5.4pt;margin-left:5.4pt;border-collapse:collapse; border: 1px solid #dddddd;'>
  
        <tr style="border: none;" >
            <td colspan="2" style="border: none;"><strong>Water System Name:</strong> </td>
            <td style="border: none;"><strong>County:</strong> </td>
        </tr>
        <tr style="border: none;"><td colspan="3" style="border: none;">&nbsp;</td></tr>
        <tr style="border: none;">
            <td style="border: none;">
                <span>
                    <strong>Chlorinated:&nbsp;</strong>
                    <input type="radio" id="Cholinated" name="Cholinated" value="yes"> Yes &nbsp;
                    <input type="radio" id="Cholinated" name="Cholinated" value="no"> No &nbsp;
                </span>
            </td>
            <td style="border: none;">
                <span>
                    <strong>Residual if Yes:</strong> _____ mg/L
                </span>
            </td>
            <td style="border: none;">
                <span>
                    
                    <strong>Submit to OHA-DWP:</strong><br />
                    <input type="radio" id="submittooha" name="submittooha" value="yes"> Yes &nbsp;
                    <input type="radio" id="submittooha" name="submittooha" value="no"> No &nbsp;
                </span>
            </td>
        </tr>
        <tr  style="border: none;">
            <td  style="border: none;" colspan="3"> 
                <br />
                <span>
                    <input type="checkbox" name="distributed" />	Distribution (Point of Use) <br />
                </span>
            </td>
        </tr>
        <tr  style="border: none;">
            <td  style="border: none;" colspan="3"> 
                <span>
                    &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="checkbox" name="Routine" />	Routine &nbsp;&nbsp;
                    <input type="checkbox" name="Repeat" />	* Repeat (See Below) &nbsp;&nbsp;
                    <input type="checkbox" name="TempRoutine" />	Temporary Routine &nbsp;&nbsp;
                    <input type="checkbox" name="Special" />	Special &nbsp;&nbsp;
                </span>
                <br />
            </td>
        </tr>
        <tr  style="border: none;">
            <td  style="border: none;" colspan="3"> 
                <span>
                    <input type="checkbox" name="source" />	Source (Raw Water Sample)<br />
                </span>
            </td>
        </tr>
        <tr  style="border: none;">
            <td  style="border: none;" colspan="3"> 
                <span>
                    &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="checkbox" name="Assessment" />	Assessment &nbsp;&nbsp;
                    <input type="checkbox" name="Triggered" />	* Triggered &nbsp;&nbsp;
                    <input type="checkbox" name="Confirmation" />	* Confirmation &nbsp;&nbsp;
                    <br />
                </span>
                <br />
            </td>
        </tr>
        <tr  style="border: none;">
            <td  style="border: none;" colspan="3"> 
                <br />
                <strong>
                    <span>
                        *ff Repeat,date of initial positive:
                        _____________
                        &nbsp;&nbsp;Sample Id of initial positive:
                        _____________
                    </span>
                </strong>
            </td>
        </tr>
        <tr  style="border: none;">
            <td  style="border: none;" colspan="3"> 
                <br />
                <strong>
                    <span>
                        *ff Repeat,location:
                        &nbsp;<input type="checkbox" name="upstream" />    Upstream &nbsp;&nbsp;
                        &nbsp;<input type="checkbox" name="same" />    Same &nbsp;&nbsp;
                        &nbsp;<input type="checkbox" name="Downstream" />    Downstream &nbsp;&nbsp;
                        &nbsp;<input type="checkbox" name="other" />    Other &nbsp;&nbsp;
                        ___________
                    </span>
                </strong>
            </td>
        </tr>
    </table>
    <br />
    <br />
    <!--public water system only info-->
    <span>
        LAB USE ONLY:
        <span> 
            &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
        </span>           
        Temp. Gun: Qi-001&nbsp;___________°C
    </span>

    <table border=1 cellspacing=0 cellpadding=0 width=1200px
    style='padding:0in 5.4pt 0in 5.4pt;margin-left:5.4pt;border-collapse:collapse;border:none;'>
        <tr>
            <td style='padding:0in 5.4pt 0in 5.4pt;' colspan="2">
                <br />

                <span>Received: Date/Time/Initials: 
                    ________________
                    &nbsp;&nbsp;
                </span>

                <span>Lab Sample ID: 
                    ________________
                    &nbsp;&nbsp;
                </span>
                <br />
                <br />

                <b>
                    <input type="checkbox" name="collected" />	Collected in accordance with FT-295 (Side 1) - Sample acceptance criteria met.<br />
                </b>
                <br />
                <span>
                    Reason for invalidation: __________________________________
                </span>

                <br />
                <br />
                <span>
                    Prepayment received: __________________________________
                </span>
                <br />
                <br />
            </td>
        </tr>
    </table>
    <br />
    <span>
        Sample Bottle Lot#: _________________
        Exp. Date: _________________
    </span>


    <!-- page 2-->
        <span class="page-break"></span>
    

    Umpqua Research Company  - Table Rock<br />
    422 SW 6TH ST, PENDLETON, OR 97801<br />
    PHONE: (541) 276-0385<br />
    ORELAP  ID#OR100061<br />

    <p style='text-align:center'>
        
        <span >
            IMPORTANT - READ ALL INSTRUCTIONS<br /><br />
            IMPROPER SAMPLING or DOCUMENTATION<br /><br />
            MAY RESULT IN YOUR SAMPLE BEING REJECTED.<br /><br />
        </span>
    </p>

    <span >
    BACTERIOLOGICAL SAMPLING PROCEDURES:<br />
    <p>
        This test uses the clear bottle with the white cap. This bottle is for bacteria testing only. Ensure that the seal around the white cap is intact. If the seal is broken, <u>DO NOT USE</u>  .
        <br /><br />
        <u>DO NOT</u> rinse the bottle. The white powder inside the bottle is critical to the test.<br />
        <u>DO NOT</u>  touch the neck of the bottle or the inside of the cap.<br />
        <u>DO NOT</u>  use swivel or flex hose faucets.<br />
    </p>
    <br />
    1.	Remove any aerator, strainer, hose attachment or back flow valve.
    <br />
    2.	Disinfect the tap with an alcohol or dilute bleach solution.
    <br />
    3.	Let sit for 30-60 seconds before turning on tap.
    <br />
    4.	Run water for 2-3 minutes before sampling. WELL SAMPLES: run for 5-1O minutes.
    <br />
    5.	Adjust the flow to create a pencil thin stream.
    <br />
    6.	Fill the bottle between the 100 ml fill line and the 120 ml fill line.
    <br />
    7.	Label the bottle using a permanent marker.
    <br />

    <br />
    <u>NITRATE AND ARSENIC SAMPLING PROCEDURES:<br /></u>N
    1.	Rinse the frosted plastic bottles several times with the water to be tested and fill to them to the neck.<br />
    2.	Cap securely.<br />
    3.	Label the bottle using a permanent marker.<br />

    <br />
    <u>RETURNING SAMPLES FOR TESTING:</u><br /><br />
    <u>Samples must be returned within 24 hours after sampling.</u><br />
    1.	Complete the Chain of Custody form in ink and return with samples.<br />
    2.	Samples must be kept refrigerated or on ice until received in the lab. DO NOT FREEZE.<br />
    3.	Payment is due at the time samples are received in the lab.<br />
    <br />
    NOTE: When testing for nitrate on a Friday, the sample MUST reach the lab by 2:00 PM. Please call the lab to inquire about hours during holidays and holiday weekends. Bacteriological samples brought in the Friday of a holiday weekend will not be accepted.
    <br /><br />
    Our laboratory uses Standard Method SM 9223 B to determine the Coliform Presence/Absence.
    <br />
    SAMPLE MAY BE REJECTED IF:<br />
    1.	Over hold time<br />
    2.	The bottle is over or under filled. (Bacteria Only)<br />
    3.	The bottle is cracked or leaking.<br />
    4.	All sample information is not provided.<br />
    5.	Sample does not meet sample acceptance criteria for temperature.<br />

</span>
</body>
